import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {TextBoxModule} from '../../../sc-text-box/src/app/text-box/text-box.module';
import {DropDownModule} from '../../../sc-drop-down/src/app/drop-down/drop-down.module';
import {EmailModule} from '../../../sc-email/src/app/email/email.module';
import {UrlModule} from '../../../sc-url/src/app/url/url.module';
import {QrCodeGeneratorModule} from '../../../sc-q-r-code-generator/src/app/q-r-code-generator/q-r-code-generator.module';
import {ButtonModule} from '../../../sc-button/src/app/button/button.module';
import {CheckBoxModule} from '../../../sc-check-box/src/app/check-box/check-box.module';
import {DropDownExModule} from '../../../sc-drop-down-ex/src/app/drop-down-ex/drop-down-ex.module';
import {CheckListModule} from '../../../sc-check-list/src/app/check-list/check-list.module';
import {RadioListModule} from '../../../sc-radio-list/src/app/radio-list/radio-list.module';
import {RelatedDocumentModule} from '../../../sc-related-document/src/app/related-document/related-document.module';
import {RelatedDocumentV1Module} from '../../../sc-related-document-v1/src/app/related-document/related-document.module';
import {DatatablesModule} from '../../../sc-datatables/src/app/datatables/datatables.module';
import {ReferenceNoModule} from '../../../sc-reference-no/src/app/reference-no/reference-no.module';
import {DateTimeModule} from '../../../sc-date-time/src/app/date-time/date-time.module';
import {DateTimeModuleNew} from '../../../sc-date-time-new/src/app/date-time/date-time.module';
import {PartyModule} from '../../../sc-party/src/app/party/party.module';
import {SeparatorModule} from '../../../sc-separator/src/app/separator/separator.module';
import {ApproveModule} from '../../../sc-approve/src/app/approve/approve.module';
import {QrCodeReaderModule} from '../../../sc-q-r-code-reader/src/app/q-r-code-reader/q-r-code-reader.module';
import {NumericModule} from '../../../sc-numeric/src/app/numeric/numeric.module';
import {NoteBoxModule} from '../../../sc-note-box/src/app/note-box/note-box.module';
import {SwitchBoxModule} from '../../../sc-switch-box/src/app/switch-box/switch-box.module';
import {TimeRecorderModule} from '../../../sc-time-recorder/src/app/time-recorder/time-recorder.module';
import {DocumentDownloaderModule} from '../../../sc-document-downloader/src/app/document-downloader/document-downloader.module';
import {PasswordEntryModule} from '../../../sc-password-entry/src/app/password-entry/password-entry.module';
import {UploaderModule} from '../../../sc-uploader/src/app/uploader/uploader.module';
import {SliderModule} from '../../../sc-slider/src/app/slider/slider.module';
import {PhoneNumberModule} from '../../../sc-phone-number/src/app/phone-number/phone-number.module';
import {ImportFileModule} from '../../../sc-import-file/src/app/import-file/import-file.module';
import { LazyLoaderModule } from '../../../sc-lazy-loader/src/app/lazy-loader/lazy-loader.module';
import { DropDownOpenModule } from '../../../sc-drop-down-open/src/app/drop-down-open/drop-down-open.module';
import { AuditTableModule } from '../../../sc-audit-table/src/app/audit-table/audit-table.module';
import { GanttChartModule } from '../../../sc-gantt-chart/src/app/gantt-chart/gantt-chart.module';
import { GanttChartDhtmlModule } from '../../../sc-gantt-chart-dhtml/src/app/gantt-chart-dhtml/gantt-chart-dhtml.module';
import {HelpButtonModule} from '../../../sc-help-button/src/app/help-button/help-button.module';
import {CheckListCommentModule} from '../../../sc-checklist-comment/src/app/checklist-comment/checklist-comment.module';
import {PanelCollapseModule} from '../../../sc-panel-collapse/src/app/panel-collapse/panel-collapse.module';
import {ScTimerModule} from '../../../sc-timer/src/app/sc-timer/sc-timer.module';
import {DropDownOpenV1Module} from '../../../sc-drop-down-open-v1/src/app/drop-down-open/drop-down-open.module';
import { CardTableModule } from '../../../sc-card-table/src/app/card-table/card-table.module';

@NgModule({
  declarations: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    ButtonModule,
    DropDownModule,
    TextBoxModule,
    EmailModule,
    UrlModule,
    QrCodeGeneratorModule,
    CheckBoxModule,
    DropDownExModule,
    CheckListModule,
    RadioListModule,
    RelatedDocumentModule,
    RelatedDocumentV1Module,
    DatatablesModule,
    ReferenceNoModule,
    DateTimeModule,
    DateTimeModuleNew,
    PartyModule,
    SeparatorModule,
    ApproveModule,
    QrCodeReaderModule,
    NumericModule,
    NoteBoxModule,
    SwitchBoxModule,
    TimeRecorderModule,
    DocumentDownloaderModule,
    PasswordEntryModule,
    UploaderModule,
    SliderModule,
    PhoneNumberModule,
    ButtonModule,
    ImportFileModule,
    LazyLoaderModule,
    DropDownOpenModule,
    DropDownOpenV1Module,
    AuditTableModule,
    GanttChartModule,
    GanttChartDhtmlModule,
    HelpButtonModule,
    CheckListCommentModule,
    PanelCollapseModule,
    ScTimerModule,
    CardTableModule
  ],
  providers: []
  // do not bootstrap the app component when exporting custom elements because an Angular app doesn't run. An ngDoBootstrap
  // function is defined that does nothing.
  // bootstrap: [AppComponent]
})
export class AppModule {

  constructor() {}

  // ngDoBootstrap needs to do nothing when exporting custom elements so that the normal Angular app bootstrap doesn't take place
  ngDoBootstrap() {}
}
